export const isVerifyPassword = (
  googleSSORequired,
  password,
  passwordConfirm,
  setErrorForm,
  t,
  { allowEmpty = false } = {},
) => {
  let isVerify = true;
  if (googleSSORequired !== true) {
    const pwd = password ?? "";
    const pwdConfirm = passwordConfirm ?? "";
    if (pwd.length === 0 && pwdConfirm.length === 0) {
      if (allowEmpty) {
        return true;
      }
      setErrorForm(t("settingsUsers.importErrorMissingPassword"));
      return false;
    }
    if (pwd.length < 6) {
      setErrorForm(t("Your password must be at least 6 characters long"));
      isVerify = false;
    } else if (pwd !== pwdConfirm) {
      setErrorForm(t("Your password must be similar"));
      isVerify = false;
    }
  }

  return isVerify;
};
